interface Dimension {
  label: string;
  left: number;
  right: number;
}

interface DimensionBarsProps {
  dimensions: Dimension[];
  leftName: string;
  rightName: string;
}

export default function DimensionBars({ dimensions, leftName, rightName }: DimensionBarsProps) {
  return (
    <div className="w-full">
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <span className="inline-flex items-center gap-2 text-sm font-medium text-primary-700">
          <span className="h-2.5 w-2.5 rounded-full bg-primary-500" />
          {leftName}
        </span>
        <span className="inline-flex items-center gap-2 text-sm font-medium text-secondary-700">
          {rightName}
          <span className="h-2.5 w-2.5 rounded-full bg-secondary-500" />
        </span>
      </div>

      <div className="space-y-4">
        {dimensions.map((dim) => {
          const total = dim.left + dim.right || 1;
          const leftPct = Math.round((dim.left / total) * 100);
          return (
            <div key={dim.label}>
              <div className="mb-1.5 flex items-center justify-between text-xs font-medium">
                <span className="text-primary-700">{dim.left}</span>
                <span className="text-foreground-600">{dim.label}</span>
                <span className="text-secondary-700">{dim.right}</span>
              </div>
              <div className="flex h-2.5 w-full overflow-hidden rounded-full bg-background-200">
                <span className="h-full bg-primary-500 transition-all" style={{ width: `${leftPct}%` }} />
                <span className="h-full flex-1 bg-secondary-500" />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}